import gql from 'graphql-tag'

export const getCases = gql`
  query($isTop: Boolean!, $isOpen: Boolean!, $paging: PagingQuery, $order: CaseOrder, $filter: CasesFilter!) {
    getCases  (
      filter: $filter,
      order: $order,
      paging: $paging,
      isTop: $isTop,
      isOpen: $isOpen
    ) {
      paging{ totalCount currentOffset currentLimit }
      cases {
        id
        inquiryName
        type
        priority
        closeDate
        openDate
        closed
        createdAt
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        caseManager {
          id
          username
        }
        assignedUsers {
          id
          username
        }
        recordType {
          id
          name
        }
      }
    }
  }
`

// """获取我的 Cases (2.0)"""
export const getMyCases = gql`
  query($filter: CasesFilter!, $isOpen: Boolean!, $isTop: Boolean!) {
    getMyCases  (
      filter: $filter,
      isOpen: $isOpen,
      isTop: $isTop
    ) {
      top {
        id
        inquiryName
        type
        priority
        closeDate
        openDate
        closed
        createdAt
        step
        status

        account {
          id
          name
          level
        }
        primaryContact {
          id
          name
        }
        caseManager {
          id
          username
        }
        assignedUsers {
          id
          username
        }
        recordType {
          id
          name
        }
        important
        urgent
        formsite
        producerForm
      }
      importantAndUrgent {
        id
        inquiryName
        type
        priority
        closeDate
        openDate
        closed
        createdAt
        step
        status
        account {
          id
          name
          level
        }
        primaryContact {
          id
          name
        }
        caseManager {
          id
          username
        }
        assignedUsers {
          id
          username
        }
        recordType {
          id
          name
        }
        important
        urgent
        formsite
        producerForm
      }
      important {
        id
        inquiryName
        type
        priority
        closeDate
        openDate
        closed
        createdAt
        step
        status
        account {
          id
          name
          level
        }
        primaryContact {
          id
          name
        }
        caseManager {
          id
          username
        }
        assignedUsers {
          id
          username
        }
        recordType {
          id
          name
        }
        important
        urgent
        formsite
        producerForm
      }
      urgent {
        id
        inquiryName
        type
        priority
        closeDate
        openDate
        closed
        createdAt
        step
        status
        account {
          id
          name
          level
        }
        primaryContact {
          id
          name
        }
        caseManager {
          id
          username
        }
        assignedUsers {
          id
          username
        }
        recordType {
          id
          name
        }
        important
        urgent
        formsite
        producerForm
      }
      others {
        id
        inquiryName
        type
        priority
        closeDate
        openDate
        closed
        createdAt
        step
        status
        account {
          id
          name
          level
        }
        primaryContact {
          id
          name
        }
        caseManager {
          id
          username
        }
        assignedUsers {
          id
          username
        }
        recordType {
          id
          name
        }
        important
        urgent
        formsite
        producerForm
      }
    }
  }
`

// """获取 New Cases from producer (2.0)"""
export const getNewCasesFromProducer = gql`
  query($filter: CasesFilter, $order: CaseOrder) {
    getNewCasesFromProducer  (
      filter: $filter,
      order: $order,
    ) {
      id
      ifNewProducer
      inquiryName
      type
      priority
      closeDate
      openDate
      closed
      createdAt
      step
      status
      important
      urgent
      formsite
      producerForm
      createdAt
      openDate
    }
  }
`

export const getCaseById = gql`
  query($caseId: Int!) {
    getCaseById(
      caseId: $caseId
    ) {
      id
      inquiryName
      type
      caseNote
      priority
      important
      urgent
      closed
      createdAt
      updatedAt
      status
      closeDate
      openDate
      step
      important
      urgent
      formsite
      producerForm
      ifNewProducer
      asset {
        id
        name
        notes
        property {
          id
          address1
          address2
          city
          state
          country
          zipCode
          propertyType
          owner
          price
          propertyStatus
          creationTime
          buyTime
          createdAt
          updatedAt
        }
        vehicle {
          id
          vid
          owner
          brand
          color
          type
          price
          createdAt
          updatedAt
        }
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      recordType {
        id
        name
        additionalInfo {
          title
          items {
            keyName
            type
            name
            options
            required
            emphatic
            store
            defaultVal
            addon
            displayKey
          }
        }
      }
      attachments {
        id
        type
        name
        size
        createdAt
        updatedAt
      }
      account {
        id
        name
        phone
        countryCode
        countryCallingCode
        extensionNumber
        otherPhone
        otherCountryCode
        otherCountryCallingCode
        otherExtensionNumber
        notes
        birthday
        billingAddressCountry
        billingAddressState
        billingAddressPostalCode
        billingAddressCity
        billingAddressStreet
        mailingAddressCountry
        mailingAddressState
        mailingAddressPostalCode
        mailingAddressCity
        mailingAddressStreet
        additionalInfoStr
        book {
          id
          name
        }
        recordType {
          id
          name
        }
        primaryContact {
          id
          name
        }
        attachments {
          id
          type
          name
          size
          createdAt
          updatedAt
        }
        source {
          id
          name
        }
        csr {
          id
          username
        }
        salutation
        firstName
        middleName
        lastName
        legalName
      }
      primaryContact {
        id
        name
      }
      source {
        id
        name
      }
      assignedUsers {
        id
        username
      }
      caseManager {
        id
        username
      }
      notes {
        id
        content
        createdBy {
          id
          username
        }
        createdAt
        updatedAt
      }
      insuranceCaseNotes {
        id
        content
        ifNew
        createdAt
        updatedAt
        user {
          id
          username
        }
        producer {
          id
          username
        }
        replyTo {
          id
          content
          createdAt
          user {
            id
            username
          }
          producer {
            id
            username
          }
        }
      }
      policies {
        id
        policyName
        status
        type
        cancelDate
        shouldAutoCancel
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        closed
        createdAt
        updatedAt
        caseId
        additionalInfoStr
        installmentPlan
        billingType
        isPremiumPayOff
        isCommissionPayOff
        productCommissionOverride
        caseId
        bindDate
        payerType
        nonRenew
        cancelDate
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        generalAgent {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        book {
          id
          name
        }
        recordType {
          id
          name
        }
        insuranceQuote {
          id
          name
        }
        writingAgents {
          id
          username
        }
        inheritPolicies {
          fromPolicy {
            id
            policyName
          }
        }
      }
      quotes {
        id
        name
        status
        type
        originalInceptionDate
        commissionPaymentEffectiveDate
        commissionPaymentExpirationDate
        closed
        createdAt
        updatedAt
        federalEmployerIdNumber
        additionalInfoStr
        caseId
        premiums {
          id
          carrierId
          carrierName
          gaId
          gaName
          effectiveDate
          term
          expirationDate
          closeDate
          installmentPlan
          billingType
          payerType
          premium
          agencyFee
          carrierPolicyFee
          inspectionFee
          stampingFee
          brokerFee
          taxesFee
          commission
          createdAt
          updatedAt
          totalAmount
          totalProjectCommission
        }
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        priorTerm {
          id
          policyName
          type
          nonRenew
          recordType {
            id
            name
          }
          account {
            id
            name
          }
          writingAgents {
            id
            username
          }
        }
        labels {
          id
          content
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      tasks {
        id
        title
        status
        dueDate
        reminderDate
        priority
        assignedTo {
          id
          username
        }
        createdAt
        createdBy {
          id
          username
        }
      }
    }
  }
`

export const newCase = gql`
  mutation($caseInput: CaseInput!) {
    newCase(
      caseInput: $caseInput
    ) {
      id
    }
  }
`

export const editCaseById = gql`
  mutation($caseInput: CaseInput!, $caseId: Int!) {
    editCaseById(
      caseInput: $caseInput,
      caseId: $caseId
    ) {
      id
    }
  }
`

export const updateCaseClient = gql`
  mutation($accountName: String, $accountId: Int, $caseId: Int!) {
    updateCaseClient(
      accountName: $accountName,
      accountId: $accountId,
      caseId: $caseId) {
      id
    }
  }
`

export const deleteCaseById = gql`
  mutation($caseId: Int!) {
    deleteCaseById(
      caseId: $caseId
    )
  }
`

export const assignCase = gql`
  mutation($caseId: Int!, $userIds: [Int!]!) {
    assignCase(
      userIds: $userIds,
      caseId: $caseId
    )
  }
`

export const openCase = gql`
  mutation($caseId: Int!) {
    openCase(
      caseId: $caseId
    )
  }
`

export const closeCase = gql`
  mutation($caseId: Int!) {
    closeCase(
      caseId: $caseId
    )
  }
`

export const updateCaseStatus = gql`
  mutation($caseId: Int!, $status: CaseStatus!) {
    updateCaseStatus(
      status: $status,
      caseId: $caseId
    )
  }
`

export const updateCasePriority = gql`
  mutation($caseId: Int!, $priority: Int) {
    updateCasePriority(
      priority: $priority,
      caseId: $caseId
    )
  }
`

export const newNote = gql`
  mutation($noteInput: NoteInput!) {
    newNote(
      noteInput: $noteInput
    ) {
      id
      content
    }
  }
`

export const editNote = gql`
  mutation($noteInput: NoteInput!, $noteId: Int!) {
    editNote(
      noteInput: $noteInput,
      noteId: $noteId
    ) {
      id
      content
    }
  }
`

export const deleteNoteById = gql`
  mutation($noteId: Int!) {
    deleteNoteById(
      noteId: $noteId
    )
  }
`

export const newInsuranceCaseNote = gql`
  mutation($insuranceCaseNoteInput: InsuranceCaseNoteInput!) {
    newInsuranceCaseNote(
      insuranceCaseNoteInput: $insuranceCaseNoteInput
      ) {
      id
      content
    }
  }
`

export const deleteInsuranceCaseNoteById = gql`
  mutation($insuranceCaseNoteId: Int!) {
    deleteInsuranceCaseNoteById(
      insuranceCaseNoteId: $insuranceCaseNoteId
    )
  }
`

export const editInsuranceCaseNote = gql`
  mutation($insuranceCaseNoteInput:InsuranceCaseNoteInput!, $insuranceCaseId: Int!) {
    editInsuranceCaseNote(
      insuranceCaseNoteInput: $insuranceCaseNoteInput,
      insuranceCaseId: $insuranceCaseId
      ) {
      id
      content
    }
  }
`

export const updateCaseStep = gql`
  mutation($caseId: Int!, $step: Int!) {
    updateCaseStep(
      caseId: $caseId,
      step: $step,
    )
  }
`

export const addAssetToCase = gql`
  mutation($caseId: Int!, $assetId: Int!) {
    addAssetToCase(
      caseId: $caseId,
      assetId: $assetId,
    )
  }
`

export const removeAssetFromCase = gql`
  mutation($caseId: Int!) {
    removeAssetFromCase(
      caseId: $caseId
    )
  }
`

export const getCaseHistories = gql`
  query($caseId: Int!) {
    getCaseHistories(
      caseId: $caseId
    ) {
      id
      user {
        id
        username
      }
      actionCode
      additionalInfo
      createdAt
    }
  }
`
export const updateMyTopCases = gql`
  mutation($caseIds: [Int!]!) {
    updateMyTopCases(
      caseIds: $caseIds,
    )
  }
`

export const reviewCaseStep = gql`
  mutation( $caseId: Int!,  $step: Int!) {
    reviewCaseStep(
      caseId: $caseId,
      step: $step,
    )
  }
`

export const getCaseReviews = gql`
  query($caseId: Int!) {
    getCaseReviews(
      caseId: $caseId
    ) {
      step
      reviewer {
        id
        username
      }
      updatedAt
    }
  }
`

export const updateNewCaseFromProducerAssignee = gql`
  mutation($caseId: Int!) {
    updateNewCaseFromProducerAssignee(
      caseId: $caseId,
    )
  }
`
